import type { DecimalValue } from 'skladon-types';

import { toInt, toNumber } from '../numbers';

/** Keep `undefined` (field absent). Convert decimal strings from Core to a JSON number. */
export function asNumber(value: DecimalValue | null): number | null;
export function asNumber(value: DecimalValue | null | undefined): number | null | undefined;
export function asNumber(value: DecimalValue | null | undefined): number | null | undefined {
    if (value === undefined) {
        return undefined;
    }
    return toNumber(value);
}

/** Keep `undefined`. Whole counts; fractional part is truncated toward zero. */
export function asInt(value: DecimalValue | null): number | null;
export function asInt(value: DecimalValue | null | undefined): number | null | undefined;
export function asInt(value: DecimalValue | null | undefined): number | null | undefined {
    if (value === undefined) {
        return undefined;
    }
    return toInt(value);
}
